var exports = {
  "O": "x620889e6--c546a1--no-image",
  "q": "x620889e6--c546a1--no-image-icon",
};

module.exports = exports;
